export default __webpack_public_path__ + "static/media/HomeLogo.429c0660.jpg";